namespace RioERP.Masters {
    export interface BooksForm {
        BookName: Serenity.StringEditor;
        EBookType: Serenity.EnumEditor;
        NoOfPages: Serenity.IntegerEditor;
        Cost: Serenity.DecimalEditor;
        TaxCategoryId: Serenity.IntegerEditor;
        Isbn: Serenity.StringEditor;
    }

    export class BooksForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.Books';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!BooksForm.init)  {
                BooksForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(BooksForm, [
                    'BookName', w0,
                    'EBookType', w1,
                    'NoOfPages', w2,
                    'Cost', w3,
                    'TaxCategoryId', w2,
                    'Isbn', w0
                ]);
            }
        }
    }
}
